/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Accolade } from './Accolade';
import {
    AccoladeFromJSON,
    AccoladeFromJSONTyped,
    AccoladeToJSON,
    AccoladeToJSONTyped,
} from './Accolade';

/**
 * 
 * @export
 * @interface UpdateAccoladeOutputBody
 */
export interface UpdateAccoladeOutputBody {
    /**
     * A URL to the JSON Schema for this object.
     * @type {string}
     * @memberof UpdateAccoladeOutputBody
     */
    readonly $schema?: string;
    /**
     * 
     * @type {Accolade}
     * @memberof UpdateAccoladeOutputBody
     */
    accolade: Accolade;
}

/**
 * Check if a given object implements the UpdateAccoladeOutputBody interface.
 */
export function instanceOfUpdateAccoladeOutputBody(value: object): value is UpdateAccoladeOutputBody {
    if (!('accolade' in value) || value['accolade'] === undefined) return false;
    return true;
}

export function UpdateAccoladeOutputBodyFromJSON(json: any): UpdateAccoladeOutputBody {
    return UpdateAccoladeOutputBodyFromJSONTyped(json, false);
}

export function UpdateAccoladeOutputBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAccoladeOutputBody {
    if (json == null) {
        return json;
    }
    return {
        
        '$schema': json['$schema'] == null ? undefined : json['$schema'],
        'accolade': AccoladeFromJSON(json['accolade']),
    };
}

export function UpdateAccoladeOutputBodyToJSON(json: any): UpdateAccoladeOutputBody {
    return UpdateAccoladeOutputBodyToJSONTyped(json, false);
}

export function UpdateAccoladeOutputBodyToJSONTyped(value?: Omit<UpdateAccoladeOutputBody, '$schema'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accolade': AccoladeToJSON(value['accolade']),
    };
}

